<template>
  <teleport to="body">
    <transition name="exm-fade">
      <div v-if="aberto" class="exm-overlay" @mousedown.self="fecharSePossivel">
        <transition name="exm-pop" appear>
          <div class="exm-card" role="dialog" aria-modal="true" aria-labelledby="exm-titulo">
            <button
              v-if="fase !== 'a-enviar'"
              class="exm-x"
              type="button"
              aria-label="Fechar"
              @click="fechar"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            <!-- ── 1. Formulário ─────────────────────────── -->
            <div v-if="fase === 'form'" key="form" class="exm-fase">
              <div class="exm-ilustra exm-ilustra--doc">
                <svg viewBox="0 0 120 120" width="96" height="96">
                  <rect x="26" y="14" width="68" height="88" rx="9" class="exm-doc" />
                  <path d="M76 14v16a6 6 0 006 6h12" class="exm-doc-dobra" />
                  <rect x="36" y="46" width="48" height="7" rx="2" class="exm-cel exm-cel--h" />
                  <rect x="36" y="58" width="22" height="6" rx="2" class="exm-cel" />
                  <rect x="62" y="58" width="22" height="6" rx="2" class="exm-cel" />
                  <rect x="36" y="69" width="22" height="6" rx="2" class="exm-cel" />
                  <rect x="62" y="69" width="22" height="6" rx="2" class="exm-cel" />
                  <rect x="36" y="80" width="22" height="6" rx="2" class="exm-cel" />
                  <rect x="62" y="80" width="22" height="6" rx="2" class="exm-cel" />
                  <circle cx="92" cy="92" r="15" class="exm-badge" />
                  <path d="M92 84v13m-5-5 5 5 5-5" class="exm-badge-seta" />
                </svg>
              </div>
              <h3 id="exm-titulo" class="exm-titulo">Exportar leads para Excel</h3>
              <p class="exm-sub">
                {{ intervalo ? "Leads " + intervalo + "." : "Histórico completo de leads." }}
                Recebe um link para descarregar o ficheiro.
              </p>

              <form @submit.prevent="enviar">
                <label class="exm-label" for="exm-email">Enviar para</label>
                <div class="exm-input" :class="{ 'exm-input--erro': erroLocal }">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="M22 6l-10 7L2 6" />
                  </svg>
                  <input
                    id="exm-email"
                    ref="inputEmail"
                    v-model="email"
                    type="email"
                    autocomplete="email"
                    placeholder="nome@reorganiza.pt"
                    @input="erroLocal = ''"
                  />
                </div>
                <p v-if="erroLocal" class="exm-erro-txt">{{ erroLocal }}</p>
                <p v-else class="exm-nota">Utilizadores do dashboard, @reorganiza.pt ou @republica45.com.</p>

                <div class="exm-acoes">
                  <button type="button" class="exm-btn exm-btn--sec" @click="fechar">Cancelar</button>
                  <button type="submit" class="exm-btn exm-btn--pri">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3">
                      <path d="M22 2L11 13" />
                      <path d="M22 2l-7 20-4-9-9-4 20-7z" />
                    </svg>
                    Enviar Excel
                  </button>
                </div>
              </form>
            </div>

            <!-- ── 2. A compilar e a enviar ───────────────── -->
            <div v-else-if="fase === 'a-enviar'" key="enviar" class="exm-fase exm-fase--centro">
              <div class="exm-palco">
                <!-- folha a encher-se de linhas -->
                <svg viewBox="0 0 160 130" width="190" height="154" class="exm-cena" :class="'exm-cena--' + passo">
                  <g class="exm-folha">
                    <rect x="34" y="12" width="92" height="106" rx="10" class="exm-doc" />
                    <rect x="46" y="26" width="68" height="9" rx="2.5" class="exm-cel exm-cel--h" />
                    <g v-for="i in 6" :key="i" class="exm-linha" :style="{ animationDelay: i * 0.22 + 's' }">
                      <rect x="46" :y="30 + i * 13" width="20" height="7" rx="2" class="exm-cel" />
                      <rect x="69" :y="30 + i * 13" width="20" height="7" rx="2" class="exm-cel" />
                      <rect x="92" :y="30 + i * 13" width="22" height="7" rx="2" class="exm-cel exm-cel--v" />
                    </g>
                    <rect x="34" y="12" width="92" height="3" rx="1.5" class="exm-scan" />
                  </g>
                  <!-- envelope que recebe a folha -->
                  <g class="exm-env">
                    <rect x="38" y="62" width="84" height="56" rx="8" class="exm-env-corpo" />
                    <path d="M38 70l42 28 42-28" class="exm-env-aba" />
                  </g>
                  <!-- avião de papel -->
                  <g class="exm-aviao">
                    <path d="M58 76l52-22-20 50-9-19z" class="exm-aviao-corpo" />
                    <path d="M81 85l29-31" class="exm-aviao-vinco" />
                  </g>
                  <g class="exm-rasto">
                    <circle cx="44" cy="96" r="2.2" />
                    <circle cx="34" cy="104" r="1.6" />
                    <circle cx="26" cy="110" r="1.1" />
                  </g>
                </svg>
              </div>
              <h3 class="exm-titulo">{{ passo === "compilar" ? "A compilar o Excel…" : "A enviar o email…" }}</h3>
              <p class="exm-sub">{{ passo === "compilar" ? "A juntar as leads e a formatar a folha." : "Para " + email }}</p>
              <div class="exm-progresso"><span :style="{ width: progresso + '%' }"></span></div>
            </div>

            <!-- ── 3. Feito ───────────────────────────────── -->
            <div v-else-if="fase === 'ok'" key="ok" class="exm-fase exm-fase--centro">
              <svg viewBox="0 0 100 100" width="92" height="92" class="exm-check">
                <circle cx="50" cy="50" r="42" class="exm-check-circ" />
                <path d="M31 51l13 13 26-28" class="exm-check-v" />
              </svg>
              <h3 class="exm-titulo">Pedido enviado!</h3>
              <p class="exm-sub">
                O Excel está a ser gerado e chega a <strong>{{ email }}</strong> dentro de alguns minutos.
                O link fica válido durante 7 dias.
              </p>
              <div class="exm-acoes exm-acoes--centro">
                <button type="button" class="exm-btn exm-btn--pri" @click="fechar">Fechar</button>
              </div>
            </div>

            <!-- ── 4. Erro ────────────────────────────────── -->
            <div v-else key="erro" class="exm-fase exm-fase--centro">
              <svg viewBox="0 0 100 100" width="88" height="88" class="exm-falha">
                <circle cx="50" cy="50" r="42" class="exm-falha-circ" />
                <path d="M50 30v26" class="exm-falha-l" />
                <circle cx="50" cy="69" r="3.5" class="exm-falha-p" />
              </svg>
              <h3 class="exm-titulo">Não foi possível exportar</h3>
              <p class="exm-sub">{{ erroServidor }}</p>
              <div class="exm-acoes exm-acoes--centro">
                <button type="button" class="exm-btn exm-btn--sec" @click="fechar">Fechar</button>
                <button type="button" class="exm-btn exm-btn--pri" @click="voltar">Tentar outro email</button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </teleport>
</template>

<script>
  const REGEX_EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  const espera = (ms) => new Promise((r) => setTimeout(r, ms));

  export default {
    name: "exportar-modal",
    props: {
      aberto: { type: Boolean, default: false },
      emailInicial: { type: String, default: "" },
      intervalo: { type: String, default: "" }, // ex.: "de 14/10/2026 a 16/10/2026"; vazio = histórico completo
      // (destino) => Promise<{ resultado, details }>
      pedir: { type: Function, required: true },
    },
    emits: ["fechar"],
    data() {
      return {
        fase: "form", // form | a-enviar | ok | erro
        passo: "compilar", // compilar | enviar (só animação)
        progresso: 0,
        email: "",
        erroLocal: "",
        erroServidor: "",
        timerProg: null,
      };
    },
    watch: {
      aberto(v) {
        if (v) {
          this.fase = "form";
          this.email = this.email || this.emailInicial;
          this.erroLocal = "";
          this.$nextTick(() => this.$refs.inputEmail && this.$refs.inputEmail.focus());
          document.addEventListener("keydown", this.onKey);
        } else {
          document.removeEventListener("keydown", this.onKey);
        }
      },
    },
    beforeUnmount() {
      document.removeEventListener("keydown", this.onKey);
      clearInterval(this.timerProg);
    },
    methods: {
      onKey(e) {
        if (e.key === "Escape") this.fecharSePossivel();
      },
      fecharSePossivel() {
        if (this.fase !== "a-enviar") this.fechar();
      },
      fechar() {
        clearInterval(this.timerProg);
        this.$emit("fechar");
      },
      voltar() {
        this.fase = "form";
        this.$nextTick(() => this.$refs.inputEmail && this.$refs.inputEmail.focus());
      },
      async enviar() {
        const destino = (this.email || "").trim();
        if (!REGEX_EMAIL.test(destino)) {
          this.erroLocal = "Indique um email válido.";
          return;
        }
        this.email = destino;
        this.fase = "a-enviar";
        this.passo = "compilar";
        this.progresso = 4;
        clearInterval(this.timerProg);
        // A barra avança sozinha até 90% e só fecha quando o servidor responde
        this.timerProg = setInterval(() => {
          this.progresso = Math.min(90, this.progresso + (90 - this.progresso) * 0.08 + 0.6);
        }, 90);

        const [r] = await Promise.all([
          this.pedir(destino),
          espera(1700), // tempo mínimo para a animação da folha se ver
        ]);

        if (r && r.resultado === "OK") {
          this.passo = "enviar";
          await espera(1500); // avião a voar
          clearInterval(this.timerProg);
          this.progresso = 100;
          await espera(350);
          this.fase = "ok";
        } else {
          clearInterval(this.timerProg);
          this.erroServidor = (r && r.details) || "Erro de ligação ao servidor.";
          this.fase = "erro";
        }
      },
    },
  };
</script>

<style>
  /* Sem scoped: o modal vive no <body> (teleport). Tudo prefixado com exm-. */
  .exm-overlay {
    position: fixed;
    inset: 0;
    z-index: 3000;
    background: rgba(3, 38, 34, 0.45);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
  .exm-card {
    position: relative;
    width: 100%;
    max-width: 440px;
    background: #fff;
    border-radius: 18px;
    padding: 30px 30px 26px;
    box-shadow: 0 24px 60px rgba(3, 38, 34, 0.28);
    font-family: inherit;
    color: #1f2421;
  }
  .exm-x {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #8a938f;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, color 0.15s;
  }
  .exm-x:hover {
    background: #f1f3f1;
    color: #1f2421;
  }
  .exm-fase {
    animation: exm-entra 0.35s ease both;
  }
  .exm-fase--centro {
    text-align: center;
  }
  .exm-ilustra {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }
  .exm-titulo {
    font-size: 19px;
    font-weight: 700;
    color: #032622;
    margin: 6px 0 6px;
    text-align: center;
  }
  .exm-sub {
    font-size: 13.5px;
    color: #5a635f;
    line-height: 1.55;
    margin: 0 0 20px;
    text-align: center;
  }
  .exm-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #5a635f;
    margin-bottom: 7px;
  }
  .exm-input {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 46px;
    padding: 0 14px;
    border: 1.5px solid #e3e6e3;
    border-radius: 11px;
    color: #8a938f;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .exm-input:focus-within {
    border-color: #4eab3e;
    box-shadow: 0 0 0 4px rgba(78, 171, 62, 0.13);
    color: #4eab3e;
  }
  .exm-input--erro,
  .exm-input--erro:focus-within {
    border-color: #c0392b;
    box-shadow: 0 0 0 4px rgba(192, 57, 43, 0.1);
    color: #c0392b;
    animation: exm-abana 0.35s;
  }
  .exm-input input {
    flex: 1;
    border: 0;
    outline: 0;
    font-size: 15px;
    color: #1f2421;
    background: transparent;
    min-width: 0;
  }
  .exm-nota,
  .exm-erro-txt {
    font-size: 12px;
    margin: 7px 2px 0;
    color: #8a938f;
  }
  .exm-erro-txt {
    color: #c0392b;
  }
  .exm-acoes {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 22px;
  }
  .exm-acoes--centro {
    justify-content: center;
  }
  .exm-btn {
    height: 42px;
    padding: 0 18px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 0;
    transition: transform 0.12s, box-shadow 0.15s, background 0.15s;
  }
  .exm-btn:active {
    transform: scale(0.97);
  }
  .exm-btn--pri {
    background: #032622;
    color: #fff;
    box-shadow: 0 6px 16px rgba(3, 38, 34, 0.22);
  }
  .exm-btn--pri:hover {
    background: #0b3a34;
    box-shadow: 0 8px 20px rgba(3, 38, 34, 0.3);
  }
  .exm-btn--sec {
    background: #f1f3f1;
    color: #1f2421;
  }
  .exm-btn--sec:hover {
    background: #e6e9e6;
  }

  /* ── ilustrações ── */
  .exm-doc {
    fill: #fff;
    stroke: #032622;
    stroke-width: 3;
  }
  .exm-doc-dobra {
    fill: none;
    stroke: #032622;
    stroke-width: 3;
    stroke-linejoin: round;
  }
  .exm-cel {
    fill: #dfe9dc;
  }
  .exm-cel--h {
    fill: #032622;
  }
  .exm-cel--v {
    fill: #4eab3e;
  }
  .exm-badge {
    fill: #4eab3e;
  }
  .exm-badge-seta {
    fill: none;
    stroke: #fff;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .exm-ilustra--doc svg {
    animation: exm-flutua 3s ease-in-out infinite;
  }

  /* ── cena "a enviar" ── */
  .exm-palco {
    display: flex;
    justify-content: center;
    margin: 4px 0 6px;
  }
  .exm-cena {
    overflow: visible;
  }
  .exm-linha {
    opacity: 0;
    animation: exm-linha 0.5s ease forwards;
  }
  .exm-scan {
    fill: #4eab3e;
    opacity: 0.85;
    animation: exm-scan 1.4s ease-in-out infinite;
  }
  .exm-folha {
    transform-origin: 80px 65px;
    transition: transform 0.6s cubic-bezier(0.6, -0.2, 0.4, 1), opacity 0.4s 0.3s;
  }
  .exm-env {
    opacity: 0;
    transform: translateY(18px);
    transition: opacity 0.35s, transform 0.45s cubic-bezier(0.2, 0.9, 0.3, 1.2);
  }
  .exm-env-corpo {
    fill: #032622;
  }
  .exm-env-aba {
    fill: none;
    stroke: #4eab3e;
    stroke-width: 3.5;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .exm-aviao,
  .exm-rasto {
    opacity: 0;
  }
  .exm-aviao-corpo {
    fill: #fff;
    stroke: #032622;
    stroke-width: 3;
    stroke-linejoin: round;
  }
  .exm-aviao-vinco {
    stroke: #032622;
    stroke-width: 2.5;
    stroke-linecap: round;
  }
  .exm-rasto circle {
    fill: #4eab3e;
  }
  /* passo 2: folha entra no envelope, o envelope vira avião e voa */
  .exm-cena--enviar .exm-folha {
    transform: translateY(30px) scale(0.55);
    opacity: 0;
  }
  .exm-cena--enviar .exm-scan {
    animation: none;
    opacity: 0;
  }
  .exm-cena--enviar .exm-env {
    opacity: 1;
    transform: translateY(0);
    animation: exm-env-some 0.35s 0.75s forwards;
  }
  .exm-cena--enviar .exm-aviao {
    animation: exm-voa 1.1s 0.85s cubic-bezier(0.45, 0, 0.3, 1) forwards;
  }
  .exm-cena--enviar .exm-rasto {
    animation: exm-rasto 1.1s 0.95s ease-out forwards;
  }

  .exm-progresso {
    height: 6px;
    border-radius: 99px;
    background: #eef1ee;
    overflow: hidden;
    margin: 4px 24px 2px;
  }
  .exm-progresso span {
    display: block;
    height: 100%;
    border-radius: 99px;
    background: linear-gradient(90deg, #4eab3e, #a9d42c);
    transition: width 0.25s ease;
  }

  /* ── sucesso / erro ── */
  .exm-check-circ {
    fill: rgba(78, 171, 62, 0.12);
    stroke: #4eab3e;
    stroke-width: 4;
    stroke-dasharray: 264;
    stroke-dashoffset: 264;
    animation: exm-traco 0.6s ease forwards;
  }
  .exm-check-v {
    fill: none;
    stroke: #4eab3e;
    stroke-width: 6;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 70;
    stroke-dashoffset: 70;
    animation: exm-traco 0.4s 0.45s ease forwards;
  }
  .exm-check {
    animation: exm-salta 0.5s 0.75s ease;
  }
  .exm-falha-circ {
    fill: rgba(192, 57, 43, 0.08);
    stroke: #c0392b;
    stroke-width: 4;
  }
  .exm-falha-l {
    stroke: #c0392b;
    stroke-width: 6;
    stroke-linecap: round;
  }
  .exm-falha-p {
    fill: #c0392b;
  }
  .exm-falha {
    animation: exm-abana 0.45s;
  }

  /* ── transições ── */
  .exm-fade-enter-active,
  .exm-fade-leave-active {
    transition: opacity 0.22s ease;
  }
  .exm-fade-enter-from,
  .exm-fade-leave-to {
    opacity: 0;
  }
  .exm-pop-enter-active {
    transition: transform 0.32s cubic-bezier(0.2, 0.9, 0.3, 1.25), opacity 0.22s;
  }
  .exm-pop-enter-from {
    transform: translateY(14px) scale(0.94);
    opacity: 0;
  }

  @keyframes exm-entra {
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: none; }
  }
  @keyframes exm-flutua {
    0%, 100% { transform: translateY(0); }
    50%      { transform: translateY(-5px); }
  }
  @keyframes exm-linha {
    from { opacity: 0; transform: translateX(-8px); }
    to   { opacity: 1; transform: none; }
  }
  @keyframes exm-scan {
    0%   { transform: translateY(0); }
    50%  { transform: translateY(100px); }
    100% { transform: translateY(0); }
  }
  @keyframes exm-env-some {
    to { opacity: 0; transform: scale(0.8); }
  }
  @keyframes exm-voa {
    0%   { opacity: 0; transform: translate(0, 0) rotate(0deg) scale(0.7); }
    15%  { opacity: 1; transform: translate(0, 0) rotate(-4deg) scale(1); }
    100% { opacity: 0; transform: translate(120px, -90px) rotate(-12deg) scale(0.6); }
  }
  @keyframes exm-rasto {
    0%   { opacity: 0; transform: translate(0, 0); }
    30%  { opacity: 1; }
    100% { opacity: 0; transform: translate(70px, -55px); }
  }
  @keyframes exm-traco {
    to { stroke-dashoffset: 0; }
  }
  @keyframes exm-salta {
    0%, 100% { transform: scale(1); }
    50%      { transform: scale(1.08); }
  }
  @keyframes exm-abana {
    0%, 100% { transform: translateX(0); }
    25%      { transform: translateX(-6px); }
    75%      { transform: translateX(6px); }
  }
  @media (prefers-reduced-motion: reduce) {
    .exm-card *,
    .exm-card {
      animation-duration: 0.01s !important;
      animation-delay: 0s !important;
      transition-duration: 0.01s !important;
    }
  }
</style>
